import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/',
  component: getView('pages/PagePerformance'),
  name: 'performance',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'ANALYTICS - OVERALL PERFORMANCE',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-performance',
  },
};
